/**
 * Created by henian.xu on 2018/7/18.
 *
 */

import { Utils } from 'vmf';
import { Pt } from './Pt';

const { GlobalVar } = Utils;

class CmsArticle extends Pt {
    constructor() {
        super();
        this.baseUrl += '/cmsArticle';
    }

    data({ ids, title, cmsCatalogId, cmsArticleType, isAvailable, schoolOrgId, currentPage, pageSize } = {}, config) {
        return super.get(
            '/data',
            {
                ids,
                title,
                cmsCatalogId,
                cmsArticleType,
                isAvailable,
                schoolOrgId,
                currentPage,
                pageSize,
            },
            {
                isRepeat: true,
                ...config,
            },
        );
    }

    getDetail({ id }) {
        return super.get('/get', { id }).then(json => {
            const { titleImage } = json.data.data;
            if (!titleImage) {
                json.data.data.titleImage = [];
            } else {
                json.data.data.titleImage = titleImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { contentImage } = json.data.data;
            if (!contentImage) {
                json.data.data.contentImage = [];
            } else {
                json.data.data.contentImage = contentImage.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            const { voiceFile } = json.data.data;
            if (!voiceFile) {
                json.data.data.voiceFile = [];
            } else {
                json.data.data.voiceFile = voiceFile.split(',').reduce((prev, curr) => {
                    prev.push({
                        name: curr,
                        address: GlobalVar.fileBasePath + curr,
                    });
                    return prev;
                }, []);
            }
            return json;
        });
    }

    save({
        cmsArticleType,
        showType,
        id,
        title,
        subtitle,
        cmsCatalogId,
        titleImageType,
        titleImage,
        contentImageType,
        contentImage,
        voiceFile,
        digest,
        author,
        source,
        isShowReleaseTime,
        releaseTime,
        content,
        imageList,
        schoolOrgId,
    } = {}) {
        const titleImageStr = titleImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const contentImageStr = contentImage
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        const voiceFileStr = voiceFile
            .reduce((prev, curr) => {
                prev.push(curr.name);
                return prev;
            }, [])
            .join(',');
        return super.post('/save', {
            cmsArticleType,
            showType,
            id,
            title,
            subtitle,
            cmsCatalogId,
            titleImageType,
            titleImage: titleImageStr,
            contentImageType,
            contentImage: contentImageStr,
            voiceFile: voiceFileStr,
            digest,
            author,
            source,
            isShowReleaseTime,
            releaseTime,
            content,
            imageList,
            schoolOrgId,
        });
    }

    delete({ ids } = {}) {
        return super.post('/delete', {
            ids,
        });
    }
}

export default new CmsArticle();
export { CmsArticle };
